<template>
    <div class="FoldersTreeHDLComponent">

        <!-- <p>{{lang.infotext_1}}</p> -->
        <!-- <b-form-input id="input-search" v-model="searchString" :placeholder="lang.placeholder_Search"></b-form-input> -->
        <br>
        <ul v-if="isData" :id="id" class="library_ul">
            <ItemTreeHDLFolder :isPending="isPending" :revisionId="revisionId" :action="action" :lang="lang.FolderTreeItemHDL"
                class="item" :model="dataTree" :edit="true" :isLastRevision="isLastRevision" :parent="parent"></ItemTreeHDLFolder>
        </ul>
        <LoaderComponent v-if="!isData"></LoaderComponent>

    </div>
</template>

<script>
import ItemTreeHDLFolder from "@/components/shared/ItemTreeHDLFolder"
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'


export default {
    name: 'FoldersTreeHDLComponent',
    components: {
        ItemTreeHDLFolder,
        LoaderComponent
    },
    props: {
        iscategory: Boolean,
        reloadTree: Boolean,
        lang: Object,
        action: Boolean,
        revisionId: Number,
        isPending: Boolean,
        lastRevisionHistory: Object,
        parent: String
    },
    data: function () {
        return {
            open: true,
            dataItem: {},

            id: "folderTree_" + this._uid,
            name: '',
            searchString: "",
            
            dataTree: {
                
            }
        };
    },
    computed: {

        ...mapGetters({

            reloadAfterDeleteTreeFolderItem: 'reloadAfterDeleteTreeFolderItem',

        }),
        isData() {


            return this.dataTree.name != ""
        },
        isLastRevision() {
            if (this.lastRevisionHistory == undefined) {
                return
            }
            if (this.lastRevisionHistory.id == this.revisionId) {
                return true;
            }
            return false;
        }
    },
    watch: {

        reloadAfterDeleteTreeFolderItem: function (new_isData, old_isData) {
            
            if (new_isData) {
                this.loadData();
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem", false)
            }
        },

        reloadTree: function (new_isData, old_isData) {
            this.loadData();
        },
        revisionId: function (newVal) {
            
            this.dataTree.name = ""
            
            this.loadData();
        }
    },
    mounted() {

    },
    created() {
     

        this.loadData();

    },
    updated() {

    },
    methods: {
        loadData() {
            
            let vue = this;
            const obj = {
                libraryRevisionId: this.revisionId
            }
            
            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getHDLFiles", obj)
                .then((result) => {
                    
                    console.log(result)
                    if (result.status = "OK") {
                        vue.dataTree = result.data;
                    }

                })
        }

    }
}
</script>


<style lang="scss">
.FoldersTreeHDLComponent {


    .library_bold {
        font-weight: bold;
    }

    .library_ul label {
        margin-right: 0px;
    }

    .library_li {
        margin-top: 5px;
        margin-left: 0px;
        width: 100%;

    }

    .library_img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
        margin-left: 5px;
    }

    .library_ul {
        padding-left: 3px;
        line-height: 1.5em;
        list-style-type: none;

    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/FoldersTreeHDLComponent.vue